import { render } from "./GenericButton.vue?vue&type=template&id=13ef6f57"
import script from "./GenericButton.vue?vue&type=script&lang=js"
export * from "./GenericButton.vue?vue&type=script&lang=js"

import "./GenericButton.vue?vue&type=style&index=0&id=13ef6f57&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__